import { put } from '../stores';

export const FRAME_APP_MOUNTED = 'FRAME_APP_MOUNTED';

export const frameAppMounted = () => {
  put({
    type: FRAME_APP_MOUNTED,
  });
};
